import React from 'react';
import StorefrontPage from '../../components/core/StorefrontPage';
import { StorefrontConfirmationContainer } from './containers/storefront-confirmation.container';

/**
 * StorefrontConfirmationShellPage — public storefront confirmation shell.
 * Wires StorefrontConfirmationContainer into the /shop/confirmation OpenRoute.
 */
const StorefrontConfirmationShellPage: React.FC = () => {
    return (
        <StorefrontPage>
            <StorefrontConfirmationContainer />
        </StorefrontPage>
    );
};

export default StorefrontConfirmationShellPage;
